import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// AdSense Publisher: ca-pub-4557897331416844
// Replace slot IDs below with your actual AdSense ad unit slot IDs from:
// AdSense Dashboard → Ads → By ad unit → Create New → Responsive Display Ad
const AD_SLOTS = {
  horizontal: '3711827526',    // ← Replace with real slot ID
  rectangle: '5214938017',     // ← Replace with real slot ID
  sidebar: '8903621054',       // ← Replace with real slot ID
};

export default function AdUnit({ type = 'horizontal', className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { rootMargin: '200px', threshold: 0 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible || loaded) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      setLoaded(true);
    } catch (e) {
      // AdSense not ready
    }
  }, [visible, loaded]);

  const dimensions = {
    horizontal: { minHeight: '90px', style: 'display:block' },
    rectangle: { minHeight: '250px', style: 'display:block' },
    sidebar: { minHeight: '250px', style: 'display:block' },
  };

  const dim = dimensions[type] || dimensions.horizontal;

  return (
    <div ref={ref} className={`ad-unit ad-unit--${type} ${className}`} aria-label="Advertisement">
      {visible && (
        <ins
          className="adsbygoogle"
          style={{ display: 'block', minHeight: dim.minHeight }}
          data-ad-client="ca-pub-4557897331416844"
          data-ad-slot={AD_SLOTS[type]}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      )}
    </div>
  );
}

AdUnit.propTypes = {
  type:      PropTypes.oneOf(['horizontal', 'rectangle', 'sidebar']),
  className: PropTypes.string,
}

AdUnit.defaultProps = {
  type:      'horizontal',
  className: '',
}